import { POST } from "../../index";

export const selectCostCompare = (param) => POST("/v1/BigDataAnalysisController/selectCostCompare", param);
export const selectCostRate = (param) => POST("/v1/BigDataAnalysisController/selectCostRate", param);
export const selectCostList = (param) => POST("/v1/BigDataAnalysisController/selectCostList", param);

export const selectMaintainNumber = (param) => POST("/v1/maintainAnalysis/selectMaintainNumber", param);
export const selectCarMaintain = (param) => POST("/v1/maintainAnalysis/selectCarMaintain", param);
export const selectMaintain = (param) => POST("/v1/maintainAnalysis/selectMaintain", param);
